export default __webpack_public_path__ + "static/media/business-health-check.61e335cf.pdf";